export default "__VITE_ASSET__kPwJbnoy__"